/* eslint-disable react/jsx-props-no-spreading */
// We have to use props spreading because of React Router's history, match and params via props.
import React, { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { useLocation, Outlet } from "react-router-dom";

import GET_LANGUAGE_DATA_CACHE from "graphql/queries/GetLanguageDataCache";

import * as Layout from "common/layout";
import screenSize from "utils/screenSize";
import useBannerBackground from "hooks/useBannerBackground";
import { useLogOutContext } from "contexts/useLogOutContext";
import AccountSider from "./AccountSider";

const AccountLayout = () => {
  const { pathname } = useLocation();

  const logOut = useLogOutContext();
  const { data: { languageDataCache: { studyLanguageId = "1" } = {} } = {} } =
    useQuery(GET_LANGUAGE_DATA_CACHE);

  const { backgroundImage, refetchBannerBackground } = useBannerBackground();

  useEffect(() => {
    refetchBannerBackground({ id: studyLanguageId });
  }, [studyLanguageId, refetchBannerBackground]);

  // eg: extract "my-settings" from "/account/my-settings"
  const currentPathname = pathname.split("/")[2] || "";
  const upperCasedPathname = currentPathname
    .split("-")
    .map((word: string) => word.toUpperCase())
    .join(" ");

  const renderSider = () => {
    if (screenSize() === "mobile") return null;

    return (
      <Layout.Sider>
        <AccountSider currentPathname={currentPathname} logOut={logOut} />
      </Layout.Sider>
    );
  };

  return (
    <Layout.PageContent>
      <Layout.HeadingWrapper style={backgroundImage}>
        {upperCasedPathname === "MY BILLINGS"
          ? "MY BILLING"
          : upperCasedPathname}
      </Layout.HeadingWrapper>
      <Layout.Container>
        <Layout.Content>
          <Outlet />
        </Layout.Content>
        {renderSider()}
      </Layout.Container>
    </Layout.PageContent>
  );
};

export default AccountLayout;
